@use "../../styles/breakpoint.module.scss" as *;

.textPanel {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
}

.panelPadding {
    padding: var(--spacer-64) var(--spacer-32);

    @media ($below-mobile) {
        padding: var(--spacer-32);
    }
}

.quote {
    flex: 1;
    margin: 0 0 var(--spacer-16) 0;
}

.quoteText {
    composes: fontSH32 from "../../styles/typography.module.scss";
    color: var(--color-text);
    margin: 0;
    position: relative;

    p {
        margin: 0;

        &:last-of-type::after {
            content: "\201D";
            position: relative;
            inset-inline-end: -0.1em;
        }
    }
}

.openQuote {
    position: absolute;
    inset-inline-start: -0.35em;
}

.attribution {
    width: 100%;
}

.name {
    composes: fontB16 from "../../styles/typography.module.scss";
}

.positionCompany {
    composes: fontST16 from "../../styles/typography.module.scss";
    margin: var(--spacer-4) 0 0 0;
}

.leanInStatus {
    composes: fontST14 from "../../styles/typography.module.scss";
    margin: var(--spacer-8) 0 0 0;
}
